import React from 'react';
import cn from 'classnames';
import { Card } from 'reactstrap';

const IngredientSummaryCard = ({ className, notes }) => {
  return (
    <Card className={cn(className, 'pa3')}>
      <h3 className="f4 mt0">Notes</h3>
      {notes ? (
        <p>{notes}</p>
      ) : (
        <p className="info">
          <em>No notes</em>
        </p>
      )}
    </Card>
  );
};

export default IngredientSummaryCard;



// WEBPACK FOOTER //
// ./src/components/notesCard/notesCard.jsx